import React from 'react';
import './Marquee.css';

export function Marquee({
  className = '',
  reverse = false,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  ...props
}) {
  return (
    <div
      {...props}
      className={`marquee-container ${vertical ? 'marquee-vertical' : 'marquee-horizontal'} ${pauseOnHover ? 'marquee-pause-on-hover' : ''} ${className}`}
    >
      {Array(repeat)
        .fill(0)
        .map((_, i) => (
          <div
            key={i}
            className={`marquee-content ${vertical ? 'marquee-content-vertical' : 'marquee-content-horizontal'} ${reverse ? 'marquee-reverse' : ''}`}
          >
            {children}
          </div>
        ))}
    </div>
  );
}

